// Based on unikitty theme and on
// https://github.com/reduxjs/redux-devtools/blob/master/packages/redux-devtools-inspector-monitor/src/themes/inspector.ts
export default {
    scheme: 'default',
    author: 'Mihail Diordiev (https://github.com/zalmoxisus)',
    base00: '#ffffff',
    base01: '#f3f3f3',
    base02: '#e8e8e8',
    base03: '#b8b8b8',
    base04: '#585858',
    base05: '#383838',
    base06: '#282828',
    base07: '#181818',
    base08: '#d80000',
    base09: '#d65407',
    base0A: '#dc8a0e',
    base0B: '#236e25',
    base0C: '#86c1b9',
    base0D: '#1155cc',
    base0E: '#aa17e6',
    base0F: '#a16946',
};
